// import { }
declare const site: server.dto.SiteData;

type SectionConfigurations = keyof server.dto.ClientConfiguration;
export const getSectionConfiguration = (key: SectionConfigurations) => site.currentEnvironment[key] as server.dto.SectionConfiguration;
